import { render, staticRenderFns } from "./form-errors.vue?vue&type=template&id=20dc1dbb"
import script from "./form-errors.vue?vue&type=script&lang=js"
export * from "./form-errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports